import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import {
  UserSettingsPage,
  UserSettingsPageNumber,
} from '../../shared/enums/user-settings-page.enum';

export const userSettingsPageResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot,
): string => {
  return (
    UserSettingsPageNumber[route.params['page'] as UserSettingsPage] || '0'
  );
};
